import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Gallery from "@/pages/Gallery";
import Overview from "@/pages/Overview";
import ArtworkDetail from "@/pages/ArtworkDetail";
import About from "@/pages/About";
import Inquire from "@/pages/Inquire";
import Guestbook from "@/pages/Guestbook";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Gallery />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/artwork/:id" element={<ArtworkDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/inquire" element={<Inquire />} />
              <Route path="/guestbook" element={<Guestbook />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Layout>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0F0F0F",
                border: "1px solid rgba(212, 175, 55, 0.3)",
                color: "#F5F5F5",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
